import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import LanguageToggle from "@/components/LanguageToggle";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await register(email, password, name);
    setLoading(false);
    if (r.ok) nav("/app/projects");
    else setErr(r.error);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#FAF9F4]">
      <div className="hidden lg:block relative bg-black">
        <img
          src="https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Construction site"
          className="absolute inset-0 w-full h-full object-cover opacity-55"
        />
        <div className="relative z-10 h-full flex flex-col p-12 text-white">
          <Logo size={26} inverse />
        </div>
      </div>

      <div className="flex flex-col p-6 lg:p-12">
        <div className="flex justify-end"><LanguageToggle /></div>
        <div className="flex-1 flex items-center">
          <form onSubmit={submit} className="w-full max-w-sm mx-auto space-y-6" data-testid="register-form">
            <div>
              <p className="label-eyebrow flex items-center"><span className="gold-rule" />{t("sign_up")}</p>
              <h2 className="mt-3 font-[Fraunces] font-medium text-4xl text-neutral-950">{t("register_title")}</h2>
              <p className="text-neutral-500 mt-3 text-sm">{t("register_sub")}</p>
            </div>
            <div className="space-y-2">
              <Label htmlFor="name" className="label-eyebrow">{t("name")}</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name-input" className="h-11" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email" className="label-eyebrow">{t("email")}</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email-input" className="h-11" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="label-eyebrow">{t("password")}</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password-input" className="h-11" />
            </div>
            {err && <p className="text-sm text-red-600" data-testid="register-error">{err}</p>}
            <Button type="submit" disabled={loading} className="w-full bg-black hover:bg-neutral-800 rounded-full h-11 text-sm" data-testid="register-submit-button">
              {loading ? "…" : t("sign_up")}
            </Button>
            <p className="text-sm text-neutral-500">
              {t("have_account")}{" "}
              <Link to="/login" className="text-[#B8933A] font-medium hover:text-[#8C6D22]" data-testid="link-to-login">
                {t("sign_in")}
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
